import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import SelectAllButton from 'redesign/components/atoms/Buttons/select-all-button'
import Checkbox from 'redesign/components/atoms/Checkbox'
import SearchInput from 'redesign/components/atoms/SearchInput'
import { getUserName } from 'utils/person'
import EmptyPage from '../empty-pages'
import { EMPTY_PAGE_VARIANTS } from '../empty-pages/constants'
import { CardContainer, DrawerBody, DrawerContainer, SearchbarContainer } from './styles'
import type { EmployeeSearchProps } from './types'

const EmployeeSearch: React.FC<EmployeeSearchProps> = ({
  filteredPersonsList,
  onChange,
  clearText,
  searchText,
  currentSelectedPersons,
  onClick,
  isCentered,
  handleSelectAll,
  areOptionsSelected,
  reducedPadding = false,
}) => {
  const { t } = useFavurTranslation()
  const { breakpoints } = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))
  const displaySelectAllButton = handleSelectAll && !searchText

  return (
    <DrawerContainer hasButton={Boolean(handleSelectAll)} reducedPadding={reducedPadding}>
      <SearchbarContainer>
        <SearchInput
          label={t('filter.persons.search.label')}
          onChange={onChange}
          clearText={clearText}
          value={searchText}
        />
      </SearchbarContainer>
      {displaySelectAllButton ? (
        <SelectAllButton onClick={handleSelectAll} areOptionsSelected={areOptionsSelected} />
      ) : null}
      <DrawerBody>
        {filteredPersonsList?.map((option) => (
          <CardContainer key={option.id}>
            <Checkbox
              size="medium"
              onClick={() => onClick(option)}
              checked={currentSelectedPersons.includes(option.id as number)}
              label={getUserName(option)}
              labelPlacement="start"
              variant="subtitle1"
              expand
              dataTestId={getUserName(option)}
              subtitleLabel={option?.subtitle}
              disabled={option?.disabled}
            />
          </CardContainer>
        ))}
        {!filteredPersonsList?.length && (
          <EmptyPage
            variant={EMPTY_PAGE_VARIANTS.noPersonsSelected}
            isAbsolute={!isSmallScreen}
            size="small"
            isCentered={isCentered}
          />
        )}
      </DrawerBody>
    </DrawerContainer>
  )
}

export default EmployeeSearch
